import apiClient from '@/plugins/axios'

export default {
  getPreMatriculas() {
    return apiClient.get('tipocontato')
  },

  getPreMatricula(id) {
    return apiClient.get(`tipocontato/${id}`)
  },

  putPreMatriculaContacted(id, status) {
    return apiClient.put(`prematricula/contacted/${id}?status=${status}`, {})

  },

  postPreMatricula(tipocontato) {
    return apiClient.post(`tipocontato`, { tipocontato })

  },

  putPreMatricula(id, tipocontato) {
    return apiClient.put(`tipocontato/${id}`, { tipocontato })

  },

  deletePreMatricula(id) {
    return apiClient.delete(`tipocontato/${id}`)

  },

}


// WEBPACK FOOTER //
// ./src/views/PreMatricula/_services/PreMatriculaService.js